/* @flow */

import {
  FETCH_LABELS,
  FETCH_ACCESS_TYPES,
  FETCH_SUBSCRIPTION_METHODS,
  FETCH_CREDENTIALS_TYPES,
  FETCH_ENTITY_TYPES,
  TOGGLE_ENTITY_TYPE,
} from './action-types';

import { EntityType } from './types.js';

export const fetchLabels = () => ({
  type: FETCH_LABELS,
});

export const fetchAccessTypes = () => ({
  type: FETCH_ACCESS_TYPES,
});

export const fetchSubscriptionMethods = () => ({
  type: FETCH_SUBSCRIPTION_METHODS,
});

export const fetchCredentialsTypes = () => ({
  type: FETCH_CREDENTIALS_TYPES,
});

export const fetchEntityTypes = () => ({
  type: FETCH_ENTITY_TYPES,
});

export const toggleEntityType = (entityType: EntityType) => ({
  type: TOGGLE_ENTITY_TYPE,
  payload: entityType,
});



// WEBPACK FOOTER //
// ./src/app/modules/miscellaneous/actions.js